import { BaseEntity } from '@/actions/dtos/baseEntity';
import { CpvCodeDto } from '@/actions/dtos/cpvCode';
import { Address } from '@/actions/dtos/location';

export enum ProcurementActivity {
  BAULEISTUNGEN = 'Bauleistungen',
  DIENSTLEISTUNGEN = 'Dienstleistungen',
  LIEFERLEISTUNGEN = 'Lieferleistungen',
}

export enum ProcurementScope {
  NATIONAL = 'NATIONAL',
  EU = 'EU',
}

export const ProcedureType = {
  BESCHRÄNKTE_AUSSCHREIBUNG: { name: 'Beschränkte Ausschreibung', slug: 'beschränkte-ausschreibung' },
  FREIHÄNDIGE_VERGABE: { name: 'Freihändige Vergabe', slug: 'freihändige-vergabe' },
  INNOVATIONSPARTNERSCHAFT: { name: 'Innovationspartnerschaft', slug: 'innovationspartnerschaft' },
  NICHTOFFENES_VERFAHREN: { name: 'Nicht offenes Verfahren', slug: 'nicht-offenes-verfahren' },
  OFFENES_VERFAHREN: { name: 'Offenes Verfahren', slug: 'offenes-verfahren' },
  ÖFFENTLICHE_AUSSCHREIBUNG: { name: 'Öffentliche Ausschreibung', slug: 'ausschreibungsarten' },
  VERHANDLUNGSVERFAHREN_VERHANDLUNGSVERGABE: {
    name: 'Verhandlungsverfahren mit Vergabeverhandlung',
    slug: 'verhandlungsverfahren',
  },
  WETTBEWERBLICHER_DIALOG: { name: 'Wettbewerblicher Dialog', slug: 'wettbewerblicher-dialog' },
};

export const Regulation = {
  UNTERSCHWELLENVERGABEORDNUNG_UVGO: { name: 'UVgO', slug: 'unterschwellenvergabeordnung-uvgo' },
  VERGABEVERORDNUNG_VGV: { name: 'VgV', slug: 'vergabeverordnung-vgv' },
  FREIBERUFLICHE_LEISTUNGEN_VOF: { name: 'VOF', slug: 'vergabeordnung-fuer-freiberufliche-leistungen-vof' },
  BAULEISTUNGEN_VOB_A: { name: 'VOB/A', slug: 'vergabe-und-vertragsordnung-fuer-bauleistungen-vob' },
  DIENST_UND_LIEFERLEISTUNGEN_VOL_A: { name: 'VOL/A', slug: 'vergabe-und-vertragsordnung-fuer-leistungen-vol' },
  VERGABEVERORDNUNG_VERTEIDIGUNG_UND_SICHERHEIT_VSVGV: { name: 'VSVGV' },
  SEKTORENVERORDNUNG_SEKTVO: { name: 'SektVO', slug: 'sektorenverordnung-sektvo' },
  KONZESSIONSVERGABEVERORDNUNG_KONZVGV: { name: 'KonzVGV', slug: 'konzessionsvergabeverordnung-konzvgv' },
};

export interface Procurement extends BaseEntity {
  procedure?: keyof typeof ProcedureType;
  summary: string;
  scope?: ProcurementScope;
  activity?: ProcurementActivity;
  cpvCodes?: CpvCodeDto[];
  executionSite?: Address;
  awardingCriteria?: string[];
  keywords: string[];
  regulation?: keyof typeof Regulation;
  officialBudget?: number;
  description?: string;
}
